export default __webpack_public_path__ + "static/media/coinbase_logo.ddc1eba5.svg";